import { resendVerificationEmail } from "../services/apiV2";
import { useState } from "react";

type TUseResendVerificationEmailParams = {
  onSuccess?: () => void;
  onError?: (e: unknown) => void;
};

export const useResendVerificationEmail = (
  params?: TUseResendVerificationEmailParams,
) => {
  const [isLoading, setIsLoading] = useState(false);

  const resend = async (email: string) => {
    setIsLoading(true);
    try {
      await resendVerificationEmail({
        email,
        emailConfirmationRedirectUrl: `${process.env.REACT_APP_SERVER_URL}/email-verify?email=${email}&token=`,
      });
      params?.onSuccess?.();
    } catch (e) {
      params?.onError?.(e);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    resend,
    isLoading,
  };
};
